<style lang="scss"></style>

<!-- eslint-disable -->
<template>
  <div class="d-flex justify-content-end">
    <b-btn :class="{'disabled': exporting}" @click="exportToCSV()" variant="primary">Export To CSV</b-btn>
  </div>
</template>
<!-- eslint-enable -->

<script>
import VisitService from '@/services/VisitService';
import { getVisitRequestedDates, getVisitBookedForDate } from '@/util/helpers';
import Papa from 'papaparse';
import { mapState } from 'vuex';

export default {
  components: {},
  props: {
    csvType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      exporting: false,
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      prison: state => state.prison.prison,
      filters: state => state.callList.filters,
    }),
  },
  mounted() {},
  methods: {
    exportToCSV() {
      this.exporting = true;

      const filters = { ...this.filters };
      filters.limit = null;
      filters.skip = null;

      VisitService.getVisits(filters).then(res => {
        const exportData = res.data.data.map(visit => {
          let base = {
            visitorName: `${visit.visitor.firstname} ${visit.visitor.lastname}`,
            prisonerName: `${visit.prisoner.firstname} ${visit.prisoner.lastname}`,
            prisonNumber: visit.prisoner.prisoner_number,
            relationship: visit.prisoner.relationship_to_booker,
            prisonName: visit.prison.name,
          };

          if (this.csvType === 'Requested') {
              base = {
                ...base,
                requestedFor: getVisitRequestedDates(visit).requestedFor1,
                isFunded: visit.is_funded ? 'yes' : 'no',
              }
          } else if (this.csvType === 'Completed') {
            base = {
              ...base,
              bookedFor: getVisitBookedForDate(visit).bookedFor,
              wasFunded: visit.is_funded ? 'yes' : 'no',
              wasTerminated: visit.was_terminated ? 'yes' : 'no',
              terminationReason: visit.was_terminated && visit.termination_reason ? visit.termination_reason : '-'
            }
          }

          return base;
        });

        const csv = Papa.unparse(exportData);
        const hiddenElement = document.createElement('a');
        hiddenElement.href = `data:text/csv;charset=utf-8,${encodeURI(csv)}`;
        hiddenElement.target = '_blank';
        hiddenElement.download = `${this.csvType}Visits-${Date.now()}.csv`;
        hiddenElement.click();
        hiddenElement.remove();
      }).finally(() => {
        this.exporting = false;
      });
    },
  },
};
</script>
